import { render } from "./completed-court.vue?vue&type=template&id=5f4ba45e"
import script from "./completed-court.vue?vue&type=script&lang=js"
export * from "./completed-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__